/*
Will apply edits to the rle collection page, and product pages for rle items

- change background to white
- ⁠remove add to cart and link image to pdp 
- ⁠change swatch colours to images.


*/

var elements = document.getElementsByClassName("product_name");
for (var i = 0; i < elements.length; i++) {
    if (elements[i].innerHTML.toLowerCase().includes("rise little earthling")) {
        //change the boddy background color to white
        document.body.style.backgroundColor = "white";

        // Change the background color of the first "image__container" to white
        var imageContainer = document.getElementsByClassName(".product_gallery")[0];
        if (imageContainer) {
            imageContainer.style.backgroundColor = "white";
            imageContainer.classList.add("white-container")
        }
        break;
    }
}

